<template>
  <div class="schoolclubsdetail-box">
    <div class="schoolclubsdetail-cont">
      <div class="club-box" v-loading="loadingData">
        <div class="club-item-content">
          <div class="avatar">
            <!-- <img
              :src="
                groupDeatail.covey_user ? groupDeatail.covey_user.groupImg : ''
              "
            /> -->
            <el-image
              :src="
                groupDeatail.covey_user ? groupDeatail.covey_user.groupImg : ''
              "
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>

          <div class="course-item-describe">
            <div class="course-item-describe-info">
              <div class="photo-box">
                <img
                  :src="
                    groupDeatail.covey_user ? groupDeatail.covey_user.photo : ''
                  "
                />
              </div>

              <div class="describe-box">
                <div class="describe-left">
                  <div class="describe-name">
                    {{ groupDeatail.societyName }}
                  </div>
                  <div class="describe-type">
                    Followers:&nbsp;{{
                      groupDeatail.covey_user
                        ? groupDeatail.covey_user.studentnums
                        : 0
                    }}
                  </div>
                </div>
                <div class="describe-right">
                  <el-button
                    class="fa fa-heart join-btn"
                    v-if="guser === -1 && userInfo && guser !== userInfo.id"
                    @click.stop="joinClub(groupDeatail.id)"
                    >Join Club</el-button
                  >
                  <el-button
                    class="el-icon-chat-dot-round send-btn"
                    @click="contactPeople"
                    >Send Message</el-button
                  >
                </div>
              </div>
            </div>
            <!-- <div class="course-item-join">
              {{ groupDeatail.covey_user ? groupDeatail.covey_user.desc : "" }}
            </div> -->
          </div>
        </div>
      </div>

      <div class="group-introduction">
        <div class="group-introduction-left">
          <div class="group-introduction-left-title">Introduction</div>
          <div class="group-introduction-left-cont">
            {{ groupDeatail.maincontent }}
          </div>
        </div>
        <div class="group-introduction-right">
          <div class="club-activity">
            <div v-if="notificationInfo && notificationInfo.content">
              <div class="club-activity-title">Activities</div>
              <div class="club-item-describe-info">
                <img
                  :src="
                    groupDeatail.covey_user ? groupDeatail.covey_user.photo : ''
                  "
                />

                <div class="describe-box describe-box-2">
                  <div class="describe-left">
                    <div class="describe-name">
                      {{ groupDeatail.societyName }}
                    </div>
                    <div class="describe-type">
                      {{
                        notificationInfo.starttime | formatTime
                      }}&nbsp;-&nbsp;{{ notificationInfo.endtime | formatTime
                      }}<el-tag
                        v-if="notificationInfo.status === 1"
                        type="warning"
                        effect="plain"
                        size="mini"
                      >
                        In progress
                      </el-tag>
                      <i style="margin-left: 8px" class="el-icon-user">
                        {{ notificationInfo.r_count }}</i
                      >

                      <el-tag
                        v-if="notificationInfo.status === 0"
                        type="info"
                        effect="plain"
                        size="mini"
                      >
                        Finished
                      </el-tag>
                    </div>
                  </div>
                  <div class="describe-join-box">
                    <el-button
                      @click="joinGroupEvent"
                      size="small"
                      :disabled="isdisabledFn"
                      >{{
                        notificationInfo.covey_mevent_user &&
                        notificationInfo.covey_mevent_user.user_id
                          ? "Joined"
                          : "Join"
                      }}</el-button
                    >
                  </div>
                </div>
              </div>
              <div class="club-activity-info">
                {{ notificationInfo.content ? notificationInfo.content : "" }}
              </div>
            </div>
            <div v-else class="club-activity-title">No Activity</div>
          </div>
        </div>
      </div>
      <div class="course-list-box_">
        <div class="courses-title" v-if="courseCount === 0">No course</div>
        <div class="courses-title" v-else-if="courseCount === 1">
          {{ courseCount }} course
        </div>
        <div class="courses-title" v-else="courseCount > 1">
          {{ courseCount }} courses
        </div>
        <div class="course-list-box list-container">
          <div
            class="course-item"
            v-for="(item, index) in courseList"
            :key="index"
            @click="gotoDetail(item.id)"
          >
            <div class="course-item-content">
              <div class="avatar">
                <el-carousel
                  trigger="click"
                  :height="screenwidth"
                  :autoplay="false"
                  indicator-position="none"
                >
                  <el-carousel-item
                    v-for="(img, index) in item.courseImg"
                    :key="index"
                    :style="{ 'background-image': 'url(' + img + ')' }"
                  >
                  </el-carousel-item>
                </el-carousel>

                <!-- <img :src="item.courseImg" /> -->
                <div class="name-box">
                  <div class="name">{{ item.courseName }}</div>
                  <!-- <div class="adress">{{ item.covey_user.realname }}</div> -->
                </div>
              </div>
              <div class="bottom">
                <div class="teacher-avatar-box">
                  <img :src="item.covey_user.photo" />
                  <span :title="item.covey_user.realname">{{
                    item.covey_user.realname
                  }}</span>
                </div>
                <div class="describe">
                  {{ item.courseDesc }}
                </div>
                <div class="split-line"></div>
                <div class="price">
                  <div class="price-num">
                    <span>Price:</span>
                    <span>C${{ (item.price / 100).toFixed(2) }}/h</span>
                  </div>
                  <!-- <div class="middle-star">
                    <img :src="require('@/assets/icon/star.png')" />
                    <span>{{ item.avgscore }}</span>
                    <span
                      class="reviews ellipsis1"
                      :title="item.evaluationtimes + ' Reviews'"
                      >({{ item.evaluationtimes }})</span
                    >
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isMoreCourses" class="view-more">
        <el-button @click.stop="loadMoreCourses">VIEW MORE COURSES</el-button>
      </div>
      <div class="courses-title" v-if="memberCount > 0">Team members</div>
      <div class="courses-title" v-else>No member</div>
      <div class="member-list-box_">
        <div class="member-list-box">
          <div
            class="member-content"
            v-for="(item, index) in memberList"
            :key="index"
          >
            <img :src="item.covey_user ? item.covey_user.photo : ''" />
            <el-tooltip
              effect="light"
              :content="item.covey_user ? item.covey_user.realname : ''"
              placement="bottom-start"
            >
              <div class="member-name">
                {{ item.covey_user ? item.covey_user.realname : "" }}
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>

      <div v-if="isMoreMembers" class="view-more">
        <el-button @click.stop="loadMoreMembers">VIEW MORE MEMBERS</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SearchTop from "./Component/SearchTop";
import RecommendCourses from "./Component/RecommendCourses";
import CourseInfo from "./Component/CourseInfo";
import { mapState } from "vuex";
import moment from "moment";
export default {
  computed: {
    ...mapState({
      xToken: (state) => state.app.token,
      userInfo: (state) => state.app.userInfo,
      schoolId: (state) => state.app.schoolId,
    }),
    isdisabledFn() {
      if (
        this.notificationInfo.covey_mevent_user &&
        this.notificationInfo.covey_mevent_user.user_id
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      loadingData: false,
      pageCourseParams: {
        page: 1,
        limit: 3,
      },
      courseCount: 0,
      pageMemberParams: {
        page: 1,
        limit: 12,
      },
      memberCount: 0,
      groupId: "",
      groupDeatail: {},
      notificationInfo: {},
      isMoreCourses: false,
      isMoreMembers: false,
      courseList: [],
      memberList: [],
      screenwidth: "",
      guser: -1,
    };
  },
  filters: {
    formatTime(val) {
      if (val && moment(val).isValid()) return moment(val).format("YYYY.MM.DD");
      else return "";
    },
  },
  components: {
    RecommendCourses,
    SearchTop,
    CourseInfo,
  },
  watch: {
    // "$route.query": function (newVal, oldVal) {
    //   this.initPage();
    // },
    // schoolId: function (newVal, oldVal) {
    //   this.getClubList();
    // },
  },
  mounted() {
    this.initCourseImgWidth();
    this.initPage();
  },
  created() {
    this.groupId = this.$route.query.groupId;
    this.guser = parseInt(this.$route.query.guser || -1);
  },
  methods: {
    initPage() {
      this.getGroupDetailByID();
      this.getGroupLatestNotification();
      this.getJoinedGroupCourseById();
      this.getGroupMemberListById();
    },
    contactPeople() {
      let id = this.groupDeatail.covey_user.id;
      if (id) {
        //判断id是否存在
        if (!this.xToken) {
          this.$store.commit("SET_LOGIN_DIALOG", true); //关闭登录dialog
          return;
        }
        if (id === this.userInfo.id) {
          this.$message.error("Can't talk to yourself!");
          return;
        }
        let routeData = this.$router.resolve({
          path: "/chat?contactId=" + id,
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$message.error("Something went wrong, please try again later");
      }
    },
    initCourseImgWidth() {
      let screenWidth = document.body.clientWidth;
      let set_width = 200;
      if (screenWidth > 1600) {
        this.screenwidth = "200px";
        return;
      } else if (screenWidth > 1160 && screenWidth <= 1600) {
        set_width = 250;
      } else if (screenWidth > 900 && screenWidth <= 1160) {
        set_width = 300;
      } else if (screenWidth > 600 && screenWidth <= 900) {
        set_width = 450;
      } else if (screenWidth <= 600) {
        set_width = 700;
      }
      this.screenwidth =
        (document.documentElement.clientWidth * set_width) / 2048 + "px";
    },
    async getGroupDetailByID() {
      this.loadingData = true;
      const { status, data, message } =
        await this.$api.courseApi.getGroupDetailByID({
          groupId: this.groupId,
        });
      if (status === "0") {
        this.groupDeatail = data;
      } else {
        this.$message.error(message);
      }
      this.loadingData = false;
    },
    async getGroupLatestNotification() {
      let eventRes = {};
      if (!this.userInfo.login_name) {
        eventRes = await this.$api.courseApi.getGroupLatestNotification({
          groupId: this.groupId,
        });
      } else {
        eventRes = await this.$api.courseApi.getGroupLatestLoginedNotification({
          groupId: this.groupId,
        });
      }
      if (eventRes.status === "0") {
        this.notificationInfo = eventRes.data;
      } else {
        this.$message.error(eventRes.message);
      }
    },
    //加入社团活动
    async joinGroupEvent() {
      const { status, data, message } =
        await this.$api.courseApi.joinGroupEvent({
          send_id: this.notificationInfo.send_id,
          c_id: this.notificationInfo.c_id,
        });
      if (status === "0") {
        this.getGroupLatestNotification();
        this.$message.success("Successfully joined");
      } else {
        this.$message.error(message);
      }
    },
    async getJoinedGroupCourseById() {
      //是否更多
      let params = { ...this.pageCourseParams };
      params["groupId"] = this.groupId;
      const { status, data } =
        await this.$api.courseApi.getJoinedGroupCourseById(params);
      if (status === "0") {
        this.isMoreCourses =
          this.pageCourseParams.page <
          Math.ceil(data.count / this.pageCourseParams.limit);
        for (let item of data.rows) {
          item["courseImg"] = item.courseImg ? JSON.parse(item.courseImg) : [];
        }
        this.courseList = data.rows;
        this.courseCount = data.count;
      }
    },
    async loadMoreCourses() {
      if (this.isMoreCourses) {
        this.pageCourseParams.page++;
        let params = { ...this.pageCourseParams };
        params["groupId"] = this.groupId;
        const { status, data } =
          await this.$api.courseApi.getJoinedGroupCourseById(params);
        //是否更多
        if (status === "0") {
          this.courseList = this.courseList.concat(data.rows);
          this.courseCount = data.count;
          this.isMoreCourses =
            this.pageCourseParams.page <
            Math.ceil(data.count / this.pageCourseParams.limit);
        }
      }
    },
    async getGroupMemberListById() {
      //是否更多
      let params = { ...this.pageMemberParams };
      params["groupId"] = this.groupId;
      const { status, data } = await this.$api.courseApi.getGroupMemberListById(
        params
      );
      if (status === "0") {
        this.isMoreMembers =
          this.pageMemberParams.page <
          Math.ceil(data.count / this.pageMemberParams.limit);
        this.memberList = data.rows;
        this.memberCount = data.count;
      }
    },
    async loadMoreMembers() {
      if (this.isMoreMembers) {
        this.pageMemberParams.page++;
        let params = { ...this.pageMemberParams };
        params["groupId"] = this.groupId;
        const { status, data } =
          await this.$api.courseApi.getGroupMemberListById(params);
        //是否更多
        if (status === "0") {
          this.memberList = this.memberList.concat(data.rows);
          this.memberCount = data.count;
          this.isMoreMembers =
            this.pageMemberParams.page <
            Math.ceil(data.count / this.pageMemberParams.limit);
        }
      }
    },

    gotoDetail(id) {
      if (!this.$route.fullPath.includes("/course")) {
        this.$router.push({ path: "/course", query: { courseId: id } });
      } else {
        this.$router.push({
          path: this.$route.fullPath,
          query: { courseId: id },
        });
      }
    },
    async joinClub(id) {
      this.$confirm("Are you sure to join?", {}).then(async () => {
        const { status, message } = await this.$api.courseApi.joinGroup({
          groupId: id,
        });
        if (status === "0") {
          this.$message({
            type: "success",
            message: message,
          });
          this.getGroupDetailByID();
        } else {
          this.$message({
            type: "warning",
            message: message,
          });
        }
      });
    },
    //退出社团
    async cancelgroup(id) {
      this.$confirm("Are you sure to cancel?", {}).then(async () => {
        const { status, message } = await this.$api.courseApi.cancelgroup({
          groupId: id,
        });
        if (status === "0") {
          this.$message({
            type: "success",
            message: message,
          });
          this.getGroupDetailByID();
        } else {
          this.$message({
            type: "warning",
            message: message,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/utils/vw.scss";
$navColor: #fff;
.schoolclubsdetail-box {
  // background: #f0f2f5;
  padding-bottom: 60px;
  .schoolclubsdetail-cont {
    max-width: 960px;
    // padding: 0 32px;
    margin: 0 auto;
    box-sizing: border-box;
    .club-activity {
      height: 100%;
      white-space: pre-line;
      // height: 260px;
      padding: 24px;
      // margin-top: 32px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
      .club-activity-title {
        height: 24px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #181d2c;
        line-height: 24px;
        margin-bottom: 6px;
      }
      .club-item-describe-info {
        width: 100%;
        padding-bottom: 10px;
        box-sizing: border-box;
        height: 84px;
        display: flex;
        align-items: center;
        img {
          width: 64px;
          height: 64px;
          border-radius: 50%;
        }
        .describe-box-2 {
          display: flex;
          flex-direction: row !important;
          justify-content: space-between !important;
          // .describe-left {
          //   display: flex;
          //   align-items: center;
          // }
          // .describe-join-box{
          //   display:flex;
          //   // flex-direction:column;
          //   // justify-content:flex-end;
          // }
        }
        .el-button {
          // width: vw(312);
          // height: vw(48);
          background: #f48c06;
          // border-radius: 32px;
          color: #ffffff;
          // font-weight: 600;
          // font-size: vw(20);
          border: none;
          &:hover {
            opacity: 0.54;
          }
        }
      }
      .describe-box {
        width: calc(100% - 64px);
        // height: 100% ;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .describe-name {
          height: 24px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #181d2c;
          line-height: 24px;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
          display: -webkit-box;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-line-clamp: 1; /*要显示的行数*/
          -webkit-box-orient: vertical;
        }
        .describe-type {
          height: 24px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #7e8088;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .el-tag {
            margin-left: 20px;
          }
        }
      }
    }
    .club-activity-info {
      padding-left: 80px;
      box-sizing: border-box;
      // height: 96px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #181d2c;
      line-height: 24px;
      word-break: break;
      // display: -webkit-box;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // -webkit-line-clamp: 4;
      // line-clamp: 4;
      // -webkit-box-orient: vertical;
    }
  }

  .club-box {
    // width: 1285px;
    margin: 0 auto;
    padding-top: 40px;
    box-sizing: border-box;
    .club-item-content {
      width: 100%;
      // height: 618px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
      cursor: pointer;
      .avatar {
        position: relative;
        width: 100%;
        height: 353px;
        .el-image {
          width: 100%;
          height: 100%;
          border-radius: 8px;
          .el-icon-picture-outline {
            font-size: 30px;
          }
        }
      }
      .course-item-describe {
        padding: 22px 48px 0px 48px;
        // height: 265px;
        box-sizing: border-box;
        .course-item-describe-info {
          width: 100%;
          padding-bottom: 38px;
          box-sizing: border-box;
          // height: 90px;
          display: flex;
          .photo-box {
            position: relative;
            top: -65px;
            // width: vw(130);
            // height: vw(130);
            width: 130px;
            height: 130px;
            padding: 5px;
            box-sizing: border-box;
            border-radius: 50%;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          img {
            // width: vw(125);
            // height: vw(125);
            width: 125px;
            height: 125px;
            border-radius: 50%;
          }
          .describe-box {
            width: calc(100% - 130px);
            height: 100%;
            padding-left: 15px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .describe-name {
              // height: 32px;
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #181d2c;
              line-height: 32px;
              overflow: hidden;
              text-overflow: ellipsis;
              // white-space: nowrap;
              word-break: break-all;
            }
            .describe-type {
              height: 30px;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #181d2c;
              line-height: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .describe-right {
              .join-btn {
                height: 48px;
                background: #f48c06;
                border-radius: 4px;
                font-size: 14px;
                color: #fff;
                font-weight: 600;
                border: none;
                /deep/ span {
                  padding-left: 10px !important;
                }
              }
              .send-btn {
                width: 196px;
                height: 48px;
                background: #f48c06;
                border-radius: 4px;
                font-size: 14px;
                color: #fff;
                font-weight: 600;
                border: none;
                /deep/ span {
                  padding-left: 10px !important;
                }
              }
            }
          }
        }
      }
    }
  }
  .courses-title {
    height: 100px;
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #201002;
    padding-top: 42px;
    padding-bottom: 26px;
    box-sizing: border-box;
    text-align: center;
  }
  .course-list-box_ {
    max-width: 1360x;
    // padding: 0 32px;
    margin: 0 auto;
  }
  .list-container {
    display: grid;
    grid-gap: 32px;
  }
  .course-list-box {
    margin-top: 16px;
    grid-template-columns: repeat(3, 1fr);
    .course-item {
      width: 100%;
      min-width: 245px;
    }
    .course-item-content {
      box-sizing: border-box;
      background: #fff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      cursor: pointer;
      &:hover {
        .describe {
          color: #f48c06;
        }
      }
      .avatar {
        position: relative;
        width: 100%;
        .el-carousel {
          overflow: hidden;
          // height: 200px;
          .el-carousel-item {
            width: 100%;
            height: 0;
            padding-bottom: 100%;
            overflow: hidden;

            background-position: center center;
            background-repeat: no-repeat;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            background-size: cover;
          }
          // height: auto;
          // /deep/.el-carousel__container{
          //     height: 200px !important;
          // }
          // /deep/ .el-carousel__item--card {
          //     width: auto !important;
          // }
          // /deep/ .el-carousel__item {
          //     width: auto !important;
          // }
        }
        .el-carousel__item {
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100%;
          transition: 0.5s;
          &:hover {
            background-size: 120%;
          }
        }
        .name-box {
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 100%;
          // padding-left: 20px;
          // box-sizing: border-box;
          color: #ffffff;
          font-weight: 600;
          line-height: 40px;
          z-index: 4;
          background: #5b5b5b44;
          .name {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            font-size: 20px;
          }
          .adress {
            font-size: 16px;
          }
        }
      }
      .bottom {
        padding: 0 20px 14px;
      }
      .describe {
        min-height: 48px;
        line-height: 24px;
        font-size: 16px;
        color: #0a033c;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        transition: 0.3s;
      }
      .teacher-avatar-box {
        height: 54px;
        display: flex;
        align-items: center;
        span {
          margin-left: 8px;
          font-size: 15px;
        }
        img {
          width: 24px;
          height: 24px;
          border-radius: 50%;
        }
      }
      .split-line {
        height: 1px;
        background: #201002;
        opacity: 0.16;
        margin-top: vw(16);
      }
      .price {
        height: vw(24);
        margin-top: vw(12);
        line-height: vw(24);
        color: #201002;
        font-size: vw(16);
        display: flex;
        justify-content: space-between;
        .price-num {
          span:nth-child(1) {
            font-size: 15px;
          }
        }
        span:nth-child(2) {
          margin-left: 4px;
          color: #f48c06;
        }

        .reviews {
          color: #a6a6a6;
        }
        .middle-star {
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .group-introduction {
    display: flex;
    // position: relative;
    margin-top: 40px;
    .group-introduction-left {
      display: inline-block;
      width: 360px;
      // height: 327px;
      background: #ffffff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 24px;
      box-sizing: border-box;
      // position: absolute;
      // top: 0;
      // bottom: 0;
      .group-introduction-left-title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #181d2c;
        line-height: 25px;
        margin-bottom: 16px;
      }
      .group-introduction-left-cont {
        white-space: pre-line;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #181d2c;
        line-height: 24px;
        // height: 260px;
        // -o-text-overflow: ellipsis;
        // text-overflow: ellipsis;
        // overflow: hidden;
      }
    }
    .group-introduction-right {
      // display: inline-block;
      width: calc(100% - 392px);
      margin-left: 32px;
      // background: #ffffff;
    }
  }
  .view-more {
    margin: 40px 0;
    text-align: center;
    .el-button {
      width: 200px;
      height: 38px;
      background: #f48c06;
      border-radius: 32px;
      color: #ffffff;
      font-weight: 600;
      // font-size: 16px;
      border: none;
    }
  }
  .member-list-box_ {
    max-width: 960px;
    margin: 0 auto;
    // padding: 0 32px;
    box-sizing: border-box;
  }
  .member-list-box {
    // width: vw(1013);

    box-sizing: border-box;
    margin: 0 auto;
    // display: flex;
    // flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    justify-content: center;
    // padding-bottom: 60px;
    .member-content {
      // width: 16.67%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      // padding: 0 24px;
      box-sizing: border-box;
      img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
      }
      .member-name {
        height: 56px;
        line-height: 56px;
        text-align: center;
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #201002;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
